import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*2,
    minWidth: '75px',
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
});

const Maintenance = ({ classes, task }) => {
  return(
    <div className={classes.root}>
      <div className={classes.divider}></div>
      <div className={classes.column}>
        {task.monthlyAmount &&
          <Typography variant="subheading">
            ${task.monthlyAmount} /mo
          </Typography>
        }
        {task.scheduleHours &&
          <Typography variant="caption">
            {task.scheduleHours} hrs /mo
          </Typography>
        }
      </div>
      <div className={classes.divider}></div>
    </div>
  );
};

export default withStyles(styles)(Maintenance);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/Total/Maintenance.jsx